export enum DropdownActions {
    search = 'search',
    addToResults = 'addToResults',
    saveAndSearch = 'saveAndSearch'
}
